import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import { useDemoModeStore } from "app/pages/sales-intelligence/store/demo-mode/useDemoModeStore";
import { trackError } from "app/pages/sales-intelligence/utils/errors/tracking";

import { useIndustryQueryClient } from "../hooks/useIndustryQueryClient";
import industryTrackingService from "../services/tracking/trackingService";
import { industryTaxonomyOptedIn } from "../store/action-creators";

export const useIndustryTransitionEnrollMutation = () => {
    const industryQueryClient = useIndustryQueryClient();

    const dispatch = useDispatch();

    return useMutation({
        mutationFn: () => salesApiService.industry.enroll(),
        retry: false,
        onSuccess: () => {
            industryTrackingService.trackImpactReportEnrollSuccess();

            // Order matters: the demo's exit reads the opt-in to decide whether to restore a legacy filter.
            industryQueryClient.markTaxonomyOptedIn();
            useDemoModeStore.getState().exitDemo();

            // Announce the opt-in; industryOptInMiddleware refreshes the now-stale industry-classified caches
            // and strips the ghost legacy filter, keeping those cross-module concerns out of this module.
            dispatch(industryTaxonomyOptedIn());
        },
        onError: trackError,
    });
};
